if( !customElements.get('download-driver-collection') ){
  customElements.define(
    'download-driver-collection',
    class DownloadDriverCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
        // 创建全局dialog 到根节点
        this.createDialogContainer();
      }

      createDialogContainer() {
        // 创建挂载节点
        this.dialogContainer = document.createElement('div');
        this.dialogContainer.id = 'download-driver-global-dialog';
        
        // 添加到根节点
        document.documentElement.appendChild(this.dialogContainer);
      }

      init() {
        this.searchInput = this.querySelector('.download-driver-heading input');
        this.tabs = this.querySelector('[slot="download-driver-tabs"]');
        this.contents = this.querySelectorAll('[slot="download-driver-content"]');
        this.tabItems = this.tabs.querySelectorAll('.tab-item');

        this.tabItems.forEach((tabItem) => {
          tabItem.addEventListener('click', (e) => {
            e.preventDefault();
            this.onTabItemClick(tabItem);
          });
        })

        this.contents.forEach((content) => {
          content.querySelectorAll('.download-driver-card').forEach((card) => {
            card.addEventListener('click', (e) => {
              e.preventDefault();
              this.onCardClick(card);
            });
          })
        })

        this.searchInput.addEventListener('change', this.onSearchChange.bind(this));



      }

      onSearchChange(e) {
        const searchText = e.target.value.toLowerCase();
        // filter card
        this.contents.forEach((item) => {
          const cardGrid = item.querySelector('.download-driver-card-grid');
          const cards = cardGrid.querySelectorAll('.download-driver-card');

          cards.forEach((card) => {
            const heading = card.querySelector('.download-driver-card-heading');
            if (heading.textContent.toLowerCase().includes(searchText)) {
              card.removeAttribute('data-hidden');
            } else {
              card.setAttribute('data-hidden', 'true');
            } 
          });
          
        });
        
      }

      onTabItemClick(tabItem) {
        const tabId = tabItem.dataset.tab;
        this.tabItems.forEach((item) => {
          item.removeAttribute('data-active');
        });
        tabItem.setAttribute('data-active', 'true');
        this.contents.forEach((item) => {
          item.removeAttribute('data-active');
          if(item.dataset.tab === tabId){
            item.setAttribute('data-active', 'true');
          }
        });
      }

      onCardClick(card) {
        const dialog = card.querySelector('div[slot="card-dialog"]');
        // dialog.showModal();
        this.openDialog(dialog);
      }

      openDialog(dialog) {
        if (!this.dialogContainer) {
          this.createDialogContainer();
        }
        
        // 保存当前滚动状态并禁止全局滚动
        this.originalHtmlOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        
        // 清空挂载节点内容
        this.dialogContainer.innerHTML = '';
        
        // 创建原生dialog元素
        const nativeDialog = document.createElement('dialog');
        nativeDialog.className = 'driver-dialog';

        // 增加遮罩层关闭事件
        nativeDialog.addEventListener('click', (e) => {
          if (e.target === nativeDialog) {
            this.closeDialog();
          }
        });
        
        // 复制原dialog的所有子元素到原生dialog中
        const dialogChildren = dialog.children;
        for (let i = 0; i < dialogChildren.length; i++) {
          nativeDialog.appendChild(dialogChildren[i].cloneNode(true));
        }
        
        // 添加关闭按钮
        // 获取dialog-close 元素 作为关闭按钮的容器
        const dialogClose = nativeDialog.querySelector('[slot="dialog-close"]');
        if(dialogClose){
          dialogClose.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeDialog();
          });
        }
        
        // 将原生dialog添加到挂载节点
        this.dialogContainer.appendChild(nativeDialog);
        
        // 激活挂载节点和dialog
        nativeDialog.showModal();
        
        // 记录当前打开的dialog
        this.currentDialog = nativeDialog;
      }

      closeDialog() {
        if (this.currentDialog) {
          this.currentDialog.close();
          this.currentDialog = null;
        }
        
        // 恢复全局滚动
        document.documentElement.style.overflow = this.originalHtmlOverflow || '';
      }

    }
  )



}